<template>
  <v-btn x-small fab elevation="0" class="mr-1 mr-2">
    <v-icon>mdi-chevron-left</v-icon>
  </v-btn>
</template>

<script>
export default {
  name: "BackButton"
};
</script>

<style scoped lang="scss"></style>
